import { translationsSiteConfig as site, name } from './translationsSiteConfig'

export const config = { site, name }
